<template>
  <div class="popup">
    <vs-popup
      :title="option.title"
      :active.sync="option.show"
      :fullscreen="option.fullscreen"
      :button-close-hidden="option.closehidden"
    >
      <slot name="content" v-if="option.hasHTML"></slot>
      <template v-else>
        <p class="text-center">
          {{ option.content }}
        </p>
      </template>
      <div ref="popupButtons">
        <vs-row vs-type="flex" v-if="buttons" vs-align="center">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            :vs-w="buttonWidth"
            v-for="(btn, i) in buttons"
            :key="i + 1"
          >
            <vs-button
              v-if="btn.type === 'OK'"
              color="primary"
              @click.prevent="btnOnClick(btn)"
              :class="btn.css"
              class="btn-block custom"
              type="filled"
              >{{ btn.text }}</vs-button
            >
            <vs-button
              v-else-if="btn.type === 'CANCEL'"
              color="#717171"
              @click.prevent="btnOnClick(btn)"
              class="btn-gray btn-block"
              >{{ btn.text }}</vs-button
            >
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" v-else>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            :vs-w="buttonWidth"
          >
            <vs-button
              color="primary"
              @click="close"
              class="btn-block"
              type="filled"
              >{{ $t("confirm.ok") }}</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
class PopupButton {
  constructor({
    css,
    color = "primary",
    onClick,
    closeOnClick = true,
    text,
    type = "OK",
    closehidden = false,
  }) {
    this.css = css;
    this.color = color;
    this.onClick = onClick;
    this.closeOnClick = closeOnClick;
    this.text = text;
    this.type = type;
    this.closehidden = closehidden;
  }
}

/**
 * option prop
 * @param {boolean} show - 노출 여부.
 * @param {string} title - 제목
 * @param {string} content - 내용. hasHTML이 true인 경우 html로 바인딩
 * @param {boolean} hasHTML - content가 HTML인지 여부
 * @param {Array<{ css: string, type: 'OK'|'CANCEL', onClick: Function, closeOnClick: boolean = true, text: string }>} buttons - 버튼들.
 */
export default {
  props: ["option"],
  data() {
    return {
      buttons: false,
    };
  },
  computed: {
    buttonWidth() {
      const buttonLength = _.clamp(
        _.get(this, ["option", "buttons", "length"], 1),
        1,
        12
      );
      return 12 / buttonLength;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    btnOnClick(btn) {
      if (btn.onClick) {
        // console.log("btn.onClick");
        // console.log(btn.onClick);
        btn.onClick();
      }
      if (btn.closeOnClick) {
        // console.log("btn.closeOnClick");
        // console.log(btn.closeOnClick);
        this.close();
      }
    },
  },
  mounted() {},
  watch: {
    option() {
      if (!this.option.buttons) {
        this.buttons = false;
      } else {
        this.buttons = this._.get(this, ["option", "buttons"], []).map(
          (btn) => new PopupButton(btn)
        );
      }
    },
  },
};
</script>

<style scoped></style>
